export const mapRadioOptions = (
  options: any[],
  handler: (id: string) => void,
) =>
  options.map(opt => ({
    ...opt,
    onPress: () => handler(opt.id),
  }));
